module.exports = __webpack_public_path__ + "media/images/athletes/1671-43ba45999606dddcec3dbdd12a446fb4.png";